"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var stimulus_1 = require("stimulus");
var ScrollToTargetController = /** @class */ (function (_super) {
    __extends(ScrollToTargetController, _super);
    function ScrollToTargetController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.connect = function () {
            var _a;
            (0, jquery_1.default)("html,body").animate({
                scrollTop: (((_a = (0, jquery_1.default)(_this.element).offset()) === null || _a === void 0 ? void 0 : _a.top) || 150) - 150
            }, 500);
        };
        return _this;
    }
    return ScrollToTargetController;
}(stimulus_1.Controller));
exports.default = ScrollToTargetController;
